(() => {

  document.addEventListener('cart:updated', () => {
    if (window.purgeIneligibleGwps) window.purgeIneligibleGwps();
  }, false);

  function isPaidLine(item) {
    return !item.properties || (!item.properties._is_auto_GWP && !item.properties._GWP);
  }

  function ruleStillAllows(item, rule, cart) {
    if (!rule.gwpProducts || !rule.gwpProducts.find(product => product.id === item.product_id)) return false;
    const eligible = cart.items.filter(cartItem => {
      return rule.gwpIncludedProducts.find(product =>
        product.id === cartItem.product_id && isPaidLine(cartItem)
      );
    });
    const totalQty = eligible.reduce((sum, cartItem) => sum + cartItem.quantity, 0);
    const minQty = rule.minQty || 0;
    return (minQty <= 0 || totalQty >= minQty) && eligible.length > 0;
  }

  function autoTierAmount(variantId, productId) {
    if (!window.gwpCartRules) return null;
    return window.gwpCartRules.tierAmount({
      variant_id: Number(variantId),
      product_id: Number(productId),
      properties: { _is_auto_GWP: 'auto-add-from-theme' }
    });
  }

  function isAutoGiftPending(variantId) {
    return Boolean(window.gwpCartRules && window.gwpCartRules.isAutoAddPending(variantId));
  }

  function hasAutoGiftInCart(cart, variantId) {
    return cart.items.some(item =>
      Number(item.variant_id) === Number(variantId) &&
      item.properties &&
      (item.properties._GWP || item.properties._is_auto_GWP) &&
      item.quantity >= 1
    );
  }

  window.collectAutoGwpChanges = function (cart, pendingRemovals) {
    const itemsToRemove = [];
    const itemsToAdd = [];
    const itemsToClamp = [];
    const settings = window.autoAddGWPSettings;

    if (!settings || !settings.enabled || !settings.rules || !settings.rules.length || !cart || !cart.items) {
      return { remove: itemsToRemove, add: itemsToAdd, clamp: itemsToClamp };
    }

    const pendingKeys = new Set((pendingRemovals || []).map(item => item.key));
    const queuedAddIds = new Set();

    for (const rule of settings.rules) {
      if (!rule.gwpProducts || !rule.gwpIncludedProducts) continue;

      const ruleGwpItems = cart.items.filter(item => {
        return rule.gwpProducts.find(product =>
          product.id === item.product_id && item.properties && item.properties._is_auto_GWP
        );
      });

      const ruleEligibleItems = cart.items.filter(item => {
        return rule.gwpIncludedProducts.find(product =>
          product.id === item.product_id && isPaidLine(item)
        );
      });

      const totalEligibleQty = ruleEligibleItems.reduce((sum, item) => sum + item.quantity, 0);
      const minQty = rule.minQty || 0;
      const meetsQtyThreshold = minQty <= 0 || totalEligibleQty >= minQty;
      const otherRules = settings.rules.filter(other => other.id !== rule.id);

      if ((!meetsQtyThreshold || ruleEligibleItems.length === 0) && ruleGwpItems.length > 0) {
        ruleGwpItems.forEach(item => {
          const keptByAnotherRule = otherRules.some(other => ruleStillAllows(item, other, cart));
          if (!keptByAnotherRule) itemsToRemove.push(item);
        });
        continue;
      }

      if (ruleEligibleItems.length > 0 && meetsQtyThreshold && ruleGwpItems.length > 0) {
        // Cap each product-triggered auto gift at quantity 1.
        let keptUnit = false;
        ruleGwpItems.forEach(item => {
          if (!keptUnit) {
            if (item.quantity > 1) itemsToClamp.push({ key: item.key, quantity: 1 });
            keptUnit = true;
            return;
          }
          itemsToRemove.push(item);
        });
        continue;
      }

      if (ruleEligibleItems.length > 0 && meetsQtyThreshold && ruleGwpItems.length === 0) {
        const paid = window.gwpCartRules ? window.gwpCartRules.paidSubtotal(cart) : 0;
        let winning = null;
        if (window.gwpCartRules) {
          cart.items.forEach(item => {
            if (pendingKeys.has(item.key)) return;
            const amount = window.gwpCartRules.tierAmount(item);
            if (amount === null || paid < amount) return;
            if (winning === null || amount > winning) winning = amount;
          });
        }

        for (let i = 0; i < rule.gwpProducts.length; i++) {
          const variantId = Number(rule.gwpVariants[i]);
          if (queuedAddIds.has(variantId)) continue;
          if (hasAutoGiftInCart(cart, variantId) || isAutoGiftPending(variantId)) continue;
          const nextAmount = autoTierAmount(variantId, rule.gwpProducts[i].id);
          // Only enforce spend-tier limits when this auto gift is itself a tier offer.
          if (nextAmount !== null && paid < nextAmount) continue;
          if (nextAmount !== null && winning !== null && nextAmount < winning) continue;
          queuedAddIds.add(variantId);
          itemsToAdd.push({
            id: variantId,
            quantity: 1,
            properties: {
              _is_auto_GWP: 'auto-add-from-theme'
            }
          });
        }
      }
    }

    const onlyGifts = cart.items.length > 0 && cart.items.every(item => {
      return item.properties && (
        item.properties._is_auto_GWP ||
        (item.properties._GWP && item.properties._GWP !== 'Palette Builder Free Well')
      );
    });
    if (onlyGifts) {
      cart.items.forEach(item => {
        if (!item.properties || item.properties._GWP === 'Palette Builder Free Well') return;
        if (item.properties._is_auto_GWP || item.properties._GWP) itemsToRemove.push(item);
      });
    }

    return { remove: itemsToRemove, add: itemsToAdd, clamp: itemsToClamp };
  };

  if (window.purgeIneligibleGwps) window.purgeIneligibleGwps();
})();
